import * as React from 'react';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {Button, Section} from 'components/UIKit';
import {HowExchange} from 'components/Marketplace';
import {FeaturedListings, FrequentlyAskedQuestions} from './components';
import {FeaturedSection} from './types';
import * as locales from './locales';
import styles from './Home.scss';

export interface HomeProps {
  shopsPath: string;
  featuredListings: FeaturedSection[];
}

export function HomeComponent({shopsPath, featuredListings, i18n}: HomeProps & WithI18nProps) {
  return (
    <>
      <Section
        heading={i18n.translate('header.heading')}
        subhead={i18n.translate('header.subhead')}
        headingProps={{type: 'h1', inheritColor: true}}
        subheadProps={{inheritColor: true}}
        headerSpacing="large"
        className={styles.Hero}
      >
        <Button url={shopsPath} label={i18n.translate('header.cta')} />
      </Section>
      {featuredListings.map((feature, index) => (
        <FeaturedListings index={index} feature={feature} key={feature.key} />
      ))}
      <HowExchange />
      <FrequentlyAskedQuestions />
    </>
  );
}

export const Home = withI18n({
  id: 'Home',
  fallback: locales.en,
})(HomeComponent);
